import React from "react";
import ReactSVG from "src/components/ReactSVG";
import { default as editIcon } from "../../../images/edit.svg";

export const FilledPanel: React.FC<{
  label: string;
  value: string | number;
  onEdit: () => void;
}> = ({ label, value, onEdit }) => (
  <div className="rounded bg-blue text-white py-3 px-5 mb-3 flex justify-betweem items-center">
    <div className="flex-grow">
      <div className="text-xs font-semibold mb-2">{label}</div>
      <div className="capitalize text-s font-bold">{value}</div>
    </div>
    <ReactSVG path={editIcon} onClick={onEdit} />
  </div>
);
